/* eslint-disable-next-line */
export interface WebDetailProps {}

export function WebDetail(props: WebDetailProps) {
  return (
    <div>
      <h1>Welcome to WebPlaDetail!</h1>
    </div>
  );
}

export default WebDetail;
